import * as React from "react";
import { MainLayout, Overlay } from "./Styles/Styles";
import { ModalAnimation, modalTransitionName, modalTransitionTimeout, } from "./ModalAnimation/ModalAnimation";
import { CSSTransition } from "react-transition-group";
import ConfirmClose from "./ConfirmClose";
import useAppSelector from "../hooks/useAppSelector";
import useRouteConfig from "../hooks/useRouteConfig";
export default function AppLayout(_a) {
    var children = _a.children;
    var routeConfig = useRouteConfig();
    var showConfirmClose = useAppSelector(function (state) { return state.navigation.showConfirmClose; });
    var hasOpened = useAppSelector(function (_a) {
        var navigation = _a.navigation;
        return navigation.hasOpened;
    });
    var open = useAppSelector(function (_a) {
        var navigation = _a.navigation;
        return navigation.open;
    });
    var ready = useAppSelector(function (_a) {
        var bootstrap = _a.bootstrap;
        return bootstrap.ready;
    });
    if (!ready || (!open && !hasOpened)) {
        return null;
    }
    return (React.createElement(Overlay, { "data-cy": "overlay" },
        React.createElement(MainLayout, { id: "container", "data-cy": "container", "data-phase": routeConfig === null || routeConfig === void 0 ? void 0 : routeConfig.page, className: "bg-white font-proxima text-black-100" },
            children,
            React.createElement(CSSTransition, { timeout: modalTransitionTimeout, classNames: modalTransitionName, in: showConfirmClose, unmountOnExit: true },
                React.createElement(ModalAnimation, null,
                    React.createElement(ConfirmClose, null))))));
}
